import {
  ColDef,
  ColumnApi,
  FirstDataRenderedEvent,
  GridApi,
  RowClassParams,
} from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { useRef } from 'react'

interface BHGridProps {
  colDefs: ColDef[]
  rowData: Quote[]
  onFirstDataRendered: (event: FirstDataRenderedEvent) => void
  onRowClicked?: (rowId: number) => void
}

function BHGrid({
  colDefs,
  rowData,
  onFirstDataRendered,
  onRowClicked,
}: BHGridProps) {
  const apiRef = useRef<GridApi>()
  const columnAPIRef = useRef<ColumnApi>()

  function getRowStyle(params: RowClassParams) {
    let color: string
    if (parseInt(params.node.id!) % 2 === 0) {
      color = 'white'
    } else {
      color = '#CA342C11'
    }

    return { backgroundColor: color }
  }

  function handleFirstDataRendered(event: FirstDataRenderedEvent) {
    event.columnApi.autoSizeAllColumns()
    onFirstDataRendered(event)
  }

  const defaultColDef = {
    sortable: true,
    filter: false,
    enableCellChangeFlash: true,
    suppressCellSelection: true,
    resizable: true,
    filterParams: {
      // Keeps filters when row data changes
      newRowsAction: 'keep',
    },
  }

  function didClickRow(event: any) {
    if (onRowClicked) {
      onRowClicked(event.node.childIndex)
    }
  }

  return (
    <div className={`ag-theme-material flex flex-1 flex-grow`}>
      <div style={{ overflow: 'hidden', flexGrow: '1' }}>
        <AgGridReact<Quote>
          suppressMenuHide
          overlayNoRowsTemplate="No Data"
          rowData={rowData}
          defaultColDef={defaultColDef}
          columnDefs={colDefs}
          suppressMovableColumns={true}
          suppressDragLeaveHidesColumns={true}
          animateRows
          onRowClicked={didClickRow}
          headerHeight={40}
          rowHeight={40}
          getRowStyle={getRowStyle}
          onFirstDataRendered={handleFirstDataRendered}
        // onFilterChanged={handleFilterChanged}
        // onRowDataChanged={updateRowCount}
        />
      </div>
    </div>
  )
}

export default BHGrid
